/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Order } from '../../models/order';

export interface ApiOrderOrdersGet$Params {
  pageIndex?: number;
  itemsToTake?: number;
}

export function apiOrderOrdersGet(http: HttpClient, rootUrl: string, params?: ApiOrderOrdersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Order>>> {
  const rb = new RequestBuilder(rootUrl, apiOrderOrdersGet.PATH, 'get');
  if (params) {
    rb.query('pageIndex', params.pageIndex, {});
    rb.query('itemsToTake', params.itemsToTake, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Order>>;
    })
  );
}

apiOrderOrdersGet.PATH = '/api/order/orders';
